<template>
    <li class="message">
        <span class="side">
            <i class="icon"></i>
        </span>
        <div class="content">
            <div class="donat">{{ message.nickname }} <span class="send">send</span> {{ message.uiValue }}</div>
            <div class="donat-deskription">{{ message?.text }}</div>
            <div class="content-bottom">
                <i class="repeat" @click="replay" v-if="!$firebase.readOnly" :disabled="message.isReplaying"></i>
                <span class="date">{{ message.date }}</span>
            </div>
        </div>
    </li>
</template>
<script>
import { Message } from "../../code/classes/Message";
export default {
    props: {
        message: { type: Message, default: undefined },
    },
    computed: {
        classes() {
            const classes = [];
            if (this.message.isRemoving) classes.push("removing");
            if (this.message.status === "Fake") classes.push("fake");
            return classes.join(" ");
        },
    },
    methods: {
        remove() {
            const id = this.message?.id;
            if (!id) return;

            this.$messages.removeInboxItem(id, () => {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        const answer = window.confirm(`Are you sure to remove '${this.message.text}'?`);
                        resolve(answer);
                    }, 100);
                });
            });
        },
        replay() {
            const id = this.message.id;
            this.$messages.replayInboxItem(id);
        },
    },
}
</script>
<style scoped lang="scss">
.message {
    display: flex;
    background: rgba(255, 255, 255, 0.07);
    border-radius: 16px 0px 0px 16px;
}

.message:not(:last-child) {
    margin-bottom: 14px;
}

.side {
    width: 28px;
    border-radius: 16px 0px 0px 16px;
    display: flex;
    align-items: center;
    background: linear-gradient(171deg, #50B79B 34.35%, #CDFCEF 115.46%);
}

.icon {
    height: 20px;
    width: 20px;
    margin-left: 4px;
    margin-right: 4px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22' fill='none'%3E%3Cg filter='url(%23filter0_f_1177_9591)'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4 4.60537C4 4.27103 4.27103 4 4.60537 4H17.4052C17.7395 4 18.0105 4.27103 18.0105 4.60537C18.0105 4.9397 17.7395 5.21074 17.4052 5.21074H11.6053V9.45482C12.902 9.47895 14.0766 9.57989 14.9727 9.73439C15.4846 9.82265 15.9349 9.93321 16.2712 10.0703C16.4366 10.1377 16.6097 10.2255 16.7516 10.3451C16.8883 10.4602 17.0781 10.6773 17.0781 10.9982C17.0781 11.319 16.8883 11.5362 16.7516 11.6513C16.6097 11.7709 16.4366 11.8586 16.2712 11.926C15.9349 12.0631 15.4846 12.1737 14.9727 12.2619C14.0766 12.4164 12.902 12.5174 11.6053 12.5415V17.3931C11.6053 17.7274 11.3342 17.9985 10.9999 17.9985C10.6656 17.9985 10.3945 17.7274 10.3945 17.3931V12.5415C9.09788 12.5174 7.92336 12.4164 7.02732 12.2619C6.5154 12.1737 6.06511 12.0631 5.72881 11.926C5.56341 11.8586 5.39031 11.7709 5.24837 11.6513C5.11175 11.5362 4.92188 11.319 4.92188 10.9982C4.92188 10.6773 5.11175 10.4602 5.24837 10.3451C5.39031 10.2255 5.56341 10.1377 5.72881 10.0703C6.06511 9.93321 6.5154 9.82265 7.02732 9.73439C7.92336 9.5799 9.09788 9.47896 10.3945 9.45482V5.21074H4.60537C4.27103 5.21074 4 4.9397 4 4.60537ZM10.3945 10.6658C9.15251 10.6898 8.04965 10.7867 7.23303 10.9275C7.10044 10.9504 6.97762 10.974 6.86471 10.9982C6.97762 11.0223 7.10044 11.0459 7.23303 11.0688C8.04965 11.2096 9.15251 11.3065 10.3945 11.3306V10.6658ZM11.6053 11.3306C12.8474 11.3065 13.9503 11.2096 14.767 11.0688C14.8996 11.0459 15.0224 11.0223 15.1353 10.9982C15.0224 10.974 14.8996 10.9504 14.767 10.9275C13.9503 10.7867 12.8474 10.6898 11.6053 10.6658V11.3306Z' fill='url(%23paint0_linear_1177_9591)'/%3E%3C/g%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4 4.60537C4 4.27103 4.27103 4 4.60537 4H17.4052C17.7395 4 18.0105 4.27103 18.0105 4.60537C18.0105 4.9397 17.7395 5.21074 17.4052 5.21074H11.6053V9.45482C12.902 9.47895 14.0766 9.57989 14.9727 9.73439C15.4846 9.82265 15.9349 9.93321 16.2712 10.0703C16.4366 10.1377 16.6097 10.2255 16.7516 10.3451C16.8883 10.4602 17.0781 10.6773 17.0781 10.9982C17.0781 11.319 16.8883 11.5362 16.7516 11.6513C16.6097 11.7709 16.4366 11.8586 16.2712 11.926C15.9349 12.0631 15.4846 12.1737 14.9727 12.2619C14.0766 12.4164 12.902 12.5174 11.6053 12.5415V17.3931C11.6053 17.7274 11.3342 17.9985 10.9999 17.9985C10.6656 17.9985 10.3945 17.7274 10.3945 17.3931V12.5415C9.09788 12.5174 7.92336 12.4164 7.02732 12.2619C6.5154 12.1737 6.06511 12.0631 5.72881 11.926C5.56341 11.8586 5.39031 11.7709 5.24837 11.6513C5.11175 11.5362 4.92188 11.319 4.92188 10.9982C4.92188 10.6773 5.11175 10.4602 5.24837 10.3451C5.39031 10.2255 5.56341 10.1377 5.72881 10.0703C6.06511 9.93321 6.5154 9.82265 7.02732 9.73439C7.92336 9.5799 9.09788 9.47896 10.3945 9.45482V5.21074H4.60537C4.27103 5.21074 4 4.9397 4 4.60537ZM10.3945 10.6658C9.15251 10.6898 8.04965 10.7867 7.23303 10.9275C7.10044 10.9504 6.97762 10.974 6.86471 10.9982C6.97762 11.0223 7.10044 11.0459 7.23303 11.0688C8.04965 11.2096 9.15251 11.3065 10.3945 11.3306V10.6658ZM11.6053 11.3306C12.8474 11.3065 13.9503 11.2096 14.767 11.0688C14.8996 11.0459 15.0224 11.0223 15.1353 10.9982C15.0224 10.974 14.8996 10.9504 14.767 10.9275C13.9503 10.7867 12.8474 10.6898 11.6053 10.6658V11.3306Z' fill='url(%23paint1_linear_1177_9591)'/%3E%3Cdefs%3E%3Cfilter id='filter0_f_1177_9591' x='0' y='0' width='22.0098' height='21.9985' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'%3E%3CfeFlood flood-opacity='0' result='BackgroundImageFix'/%3E%3CfeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape'/%3E%3CfeGaussianBlur stdDeviation='2' result='effect1_foregroundBlur_1177_9591'/%3E%3C/filter%3E%3ClinearGradient id='paint0_linear_1177_9591' x1='4.14173' y1='12.0357' x2='15.5202' y2='12.0357' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='white'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_1177_9591' x1='4.14173' y1='12.0357' x2='15.5202' y2='12.0357' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='white'/%3E%3Cstop offset='1' stop-color='white'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
}

.content {
    padding: 9px 37px 12px 12px;
    width: 100%;
}

.donat {
    margin-bottom: 5.67px;
    color: #FFF;
    font-family: Gilroy-Medium;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.send {
    color: #A0AEC0;
    font-family: Gilroy-Regular;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.donat-deskription {
    color: #A0AEC0;
    font-family: Gilroy-Regular;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.content-bottom {
    display: flex;
    margin-top: 13px;
    justify-content: space-between;
    align-items: center;
}

.repeat {
    width: 16px;
    height: 15.765px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cg clip-path='url(%23clip0_1177_9587)'%3E%3Cpath d='M8.02152 2.64645C7.82626 2.45118 7.50968 2.45118 7.31441 2.64645C7.11915 2.84171 7.11915 3.15829 7.31441 3.35355L7.79768 3.83682C4.67031 3.9441 2.16797 6.51316 2.16797 9.66667C2.16797 12.8883 4.77964 15.5 8.0013 15.5C11.223 15.5 13.8346 12.8883 13.8346 9.66667C13.8346 9.39052 13.6108 9.16667 13.3346 9.16667C13.0585 9.16667 12.8346 9.39052 12.8346 9.66667C12.8346 12.336 10.6707 14.5 8.0013 14.5C5.33193 14.5 3.16797 12.336 3.16797 9.66667C3.16797 7.06821 5.21847 4.94867 7.78964 4.83788L7.31441 5.31311C7.11915 5.50838 7.11915 5.82496 7.31441 6.02022C7.50968 6.21548 7.82626 6.21548 8.02152 6.02022L9.35486 4.68689C9.55012 4.49162 9.55012 4.17504 9.35486 3.97978L8.02152 2.64645Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_1177_9587'%3E%3Crect width='16' height='15.7647' fill='white' transform='translate(0 0.234375)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E");
}

.date {
    margin-top: 4px;
    color: #FFF;
    font-family: Gilroy-Regular;
    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

@media (min-width:1800px) {
    .message:not(:last-child) {
        margin-bottom: 11px;
    }

    .donat {
        font-size: 16px;
    }
}

@media (min-width: 0px) and (max-width: 1290px) {

    .message:not(:last-child) {
        margin-bottom: 10px;
    }

    .side {
        width: 50px;
        justify-content: center;
    }

    .icon {
        height: 24px;
        width: 24px;
        margin: 0;
    }

    .donat {
        margin-bottom: 6.67px;
    }
}

@media (max-width: 680px) {
    .side {
        width: 34px;
    }

    .icon {
        width: 20px;
        height: 20px;
    }

    .content {
        padding: 12px 21px 10px 11px;
    }
}
</style>